import { render, staticRenderFns } from "./XmCardTabs.vue?vue&type=template&id=6b4d6aa3&scoped=true"
import script from "./XmCardTabs.vue?vue&type=script&lang=js"
export * from "./XmCardTabs.vue?vue&type=script&lang=js"
import style0 from "./XmCardTabs.vue?vue&type=style&index=0&id=6b4d6aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d6aa3",
  null
  
)

export default component.exports